import { MILLISECONDS_IN_SECOND } from '../consts/common';

export function convertSecondsInMilliseconds(seconds: number): number {
  return seconds * MILLISECONDS_IN_SECOND;
}

export function rounding(item: number): number {
  return Math.round(item * 100) / 100;
}
